var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_4476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.7059H9.37683V18.2353H4V16.7059ZM4 11.3529H10.9131V12.8824H4V11.3529ZM4 6H19.3624V7.52941H4V6ZM18.3439 12.9015L19.2319 12.6025L20 13.9269L19.2963 14.5426C19.3396 14.7472 19.3624 14.9591 19.3624 15.1765C19.3624 15.3938 19.3396 15.6058 19.2963 15.8103L20 16.426L19.2319 17.7505L18.3439 17.4514C18.0285 17.7337 17.6543 17.952 17.2417 18.0857L17.058 19H15.5218L15.3381 18.0857C14.9255 17.952 14.5513 17.7337 14.236 17.4514L13.3479 17.7505L12.5798 16.426L13.2835 15.8103C13.2402 15.6058 13.2174 15.3938 13.2174 15.1765C13.2174 14.9591 13.2402 14.7472 13.2835 14.5426L12.5798 13.9269L13.3479 12.6025L14.236 12.9015C14.5513 12.6192 14.9255 12.401 15.3381 12.2672L15.5218 11.3529H17.058L17.2417 12.2672C17.6543 12.401 18.0285 12.6192 18.3439 12.9015ZM16.2899 16.7059C17.1384 16.7059 17.8261 16.0212 17.8261 15.1765C17.8261 14.3318 17.1384 13.6471 16.2899 13.6471C15.4414 13.6471 14.7537 14.3318 14.7537 15.1765C14.7537 16.0212 15.4414 16.7059 16.2899 16.7059Z",
    fill: "#5B73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_4476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.975ecfa724d2a9c34598ebc4d7a5177a.svg";
export { ForwardRef as ReactComponent };